import { createContext, Dispatch, ReactNode, SetStateAction, useCallback, useContext, useState } from 'react';

const SelectionListBarContext = createContext<[boolean, Dispatch<SetStateAction<boolean>>] | undefined>(undefined);

export const SelectionListBarProvider = ({ children }: { children: ReactNode }) => {
    const [selectionListBarExpanded, setSelectionListBarExpanded] = useState(false);

    return (
        <SelectionListBarContext.Provider value={[selectionListBarExpanded, setSelectionListBarExpanded]}>
            {children}
        </SelectionListBarContext.Provider>
    );
};

export const useSelectionListBar = () => {
    const context = useContext(SelectionListBarContext);

    if (!context) {
        throw new Error('useSelectionListBar must be used within a SelectionListBarProvider');
    }

    const [selectionListBarExpanded, setSelectionListBarExpanded] = context;

    const toggleSelectionListBar = useCallback(
        () => setSelectionListBarExpanded(current => !current),
        [setSelectionListBarExpanded]
    );

    return { selectionListBarExpanded, toggleSelectionListBar };
};
